import React from 'react'
import { FaUsers } from 'react-icons/fa'
import SongList from '../components/SongList'
import { BackButton } from '../components/BackButton'

export default function SongsPage() {
  return (
    <>
      <BackButton to="/artists" icon={<FaUsers data-set="user-icon" />}>
        <span>Artists</span>
      </BackButton>
      <SongList />
    </>
  )
}
